if (!customElements.get("m-slideshow")) {
  class MSlideshow extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed) || 4;
      this.showArrows = this.dataset.enableArrows === "true";
      this.showDots = this.dataset.enableDots === "true";
      this.adaptHeight = this.dataset.slideHeight === "adapt";
      this.id = this.dataset.id;
      this.sliderContainer = this.querySelector(".swiper-container");

      this.lastVideo = null;
      this.lastActive = null;
      this.timeout = null;
      this._swiperRetry = 0;
      this.initSlider();
    }

    initSlider() {
      if (!this.sliderContainer) return;

      // Safely ensure Swiper library is loaded from vendor.js before initializing
      if (typeof MinimogLibs === "undefined" || !MinimogLibs.Swiper) {
        if (this._swiperRetry < 60) {
          this._swiperRetry++;
          setTimeout(() => this.initSlider(), 100);
          return;
        }
      }

      if (this.slider && typeof this.slider.destroy === "function") {
        try {
          this.slider.destroy(true, true);
        } catch (e) {}
      }

      const effect = this.dataset.effect || "slide";
      const swiperConfig = {
        init: false,
        autoplay: this.autoplay
          ? {
              delay: this.autoplaySpeed * 1000,
              disableOnInteraction: false,
            }
          : false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,
        effect: effect,
        speed: effect === "fade" ? 1000 : 650,
        grabCursor: true,
        allowTouchMove: true,
        touchRatio: 1,
        touchAngle: 45,
        simulateTouch: true,
        threshold: 5,
        resistance: true,
        resistanceRatio: 0.85,
        touchEventsTarget: "container",
        navigation: this.showArrows
          ? {
              nextEl: this.querySelector(".m-slider-controls__button-next"),
              prevEl: this.querySelector(".m-slider-controls__button-prev"),
            }
          : false,
        pagination: this.showDots
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
              bulletClass: "m-dot",
              bulletActiveClass: "m-dot--active",
            }
          : false,
        on: {
          init: () => {
            setTimeout(() => {
              window.dispatchEvent(new Event("resize"));
            }, 100);
          },
        },
      };

      if (effect === "fade") {
        swiperConfig.fadeEffect = {
          crossFade: true,
        };
      }

      try {
        if (typeof MinimogLibs !== "undefined" && MinimogLibs.Swiper) {
          this.slider = new MinimogLibs.Swiper(this.sliderContainer, swiperConfig);
          this.slider.on("init", this.handleChange.bind(this));
          this.slider.on("slideChange", this.handleChange.bind(this));
          this.slider.init();
        }
      } catch (err) {
        console.warn("Error initializing Swiper:", err);
      }

      this.setupTouchSwipe();

      if (Shopify && Shopify.designMode) {
        document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
      }
    }

    setupTouchSwipe() {
      if (this._touchSwipeBound) return;
      this._touchSwipeBound = true;

      let startX = 0;
      let startY = 0;
      let distX = 0;
      let distY = 0;
      const threshold = 35;

      this.addEventListener(
        "touchstart",
        (e) => {
          if (!e.touches || !e.touches[0]) return;
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          distX = 0;
          distY = 0;
        },
        { passive: true }
      );

      this.addEventListener(
        "touchmove",
        (e) => {
          if (!startX || !startY || !e.touches || !e.touches[0]) return;
          distX = e.touches[0].clientX - startX;
          distY = e.touches[0].clientY - startY;
        },
        { passive: true }
      );

      this.addEventListener(
        "touchend",
        () => {
          if (Math.abs(distX) > Math.abs(distY) && Math.abs(distX) > threshold) {
            if (distX < 0) {
              // Swipe left -> Next slide
              if (this.slider && typeof this.slider.slideNext === "function") {
                this.slider.slideNext();
              }
            } else {
              // Swipe right -> Prev slide
              if (this.slider && typeof this.slider.slidePrev === "function") {
                this.slider.slidePrev();
              }
            }
          }
          startX = 0;
          startY = 0;
          distX = 0;
          distY = 0;
        },
        { passive: true }
      );
    }

    handleChange(swiper) {
      if (!swiper) return;
      const { activeIndex, slides } = swiper;
      const slideType = slides && slides[activeIndex] && slides[activeIndex].dataset.slideType;
      if (slideType === "video_slide") {
        const video = slides[activeIndex] && slides[activeIndex].querySelector("video");
        if (video) {
          let playPromise = video.play();
          this.lastVideo && this.lastVideo.pause();
          if (playPromise !== undefined) {
            playPromise.then(() => {
              this.lastVideo = video;
            });
          }
        }
      } else {
        this.lastVideo && this.lastVideo.pause();
        this.lastVideo = null;
      }
    }

    onBlockSelect(ev) {
      const block = ev.target;
      const index = Number(block.dataset.slide);
      this.lastActive = index;
      if (this.slider && typeof this.slider.slideToLoop === "function") {
        this.slider.slideToLoop(index);
      }
    }
  }

  customElements.define("m-slideshow", MSlideshow);
}
